import React from 'react';
import './ModulePage.css';
import './SectionCards.css';

export default function SectionContentHeading({ items, value }) {
  const section = items.find(item => item.value === value && item.visible !== false);
  if (!section) return null;
  return <div className="module-content-heading hidethis"><h2>{section.label}</h2><p>{section.description}</p></div>;
}
